import type { RouteLocationRaw, Router } from 'vue-router'

export const backOrFallback = (router: Router, fallback: RouteLocationRaw) => {
  if (router.options.history.state.back) {
    router.back()
  } else {
    router.replace(fallback)
  }
}
